import type { ConsentedPolicy } from "@/core/types";

export const ConsentPath: Record<ConsentedPolicy, string> = {
  advanced_care_program: "/advanced-care",
  eula: "/terms-and-conditions",
  hipaa: "/hipaaprivacy",
  privacy: "/privacy",
  treatment: "/consent",
} as const;
